import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledLinks = styled.ul`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleBase')};

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-row-gap: ${themeGet('scale.scaleUp03')};
    grid-template-columns: repeat(${(props) => props.columns}, 1fr);
    ${(props) =>
      props.columns > 1 &&
      `
      grid-template-rows: repeat(3, minmax(0, auto));
      grid-auto-flow: column;
    `};
  }
`;

export const StyledCtas = styled.ul`
  margin-top: ${themeGet('scale.scaleUp05')};
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleUp05')};

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  }
`;
